import React from 'react';
import { Link } from 'react-router-dom';
import "../introduction.css";

const credentialHighlights = (props) => {

    const creds = props.data.certificates.map((cred) => {
        return  <div className='cred_course center flex_column'>
            <div className='prj_title'>
                {cred.name}
            </div>
            <div className='prj_description'>
                {cred.organization}
            </div>
        </div>
    })

    return (
        /*<div id='me_creds'>
            <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                <div className='center' style={{flexWrap: "wrap"}}>
                    {creds}
                </div>
                <div className='poster_hr' />
                <div className='view_more center flex_column'>
                    View all my credentials and courses in detail.
                    <div className='view_more_link'>
                        <Link className='more_link' to='credentials'>Visit Credential Details</Link>
                    </div>
                </div>
            </div>
            <div className='poster_right'>
                <div className='poster'>
                    Credentials
                    <div className='poster_hr'/>
                    <div className='poster_subheading'>
                        View my credentials, certifications and courses I have completed.
                    </div>
                </div>
            </div>
        </div>*/
        <div id='me_creds'>
            <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                <div className='poster'>
                    Credentials
                    <div className='poster_hr'/>
                    <div className='poster_subheading'>
                        View my credentials, certifications and courses I have completed.
                    </div>
                    <div className='view_more_link'>
                        <Link className='more_link' to='credentials'>View Credentials in Detail</Link>
                    </div>
                </div>
            </div>
            <div className='poster_right center flex_column'>
                {creds}
            </div>
        </div>
    )
}

export default credentialHighlights;